import axios from '../helper/Axios';
import md5 from 'md5';
import handleException from './errorHandling';
import config from '../../config';
import jwt_decode from 'jwt-decode';

export const getServiceRegion = async (email_or_phone, open_url) => {
    try {
        let new_email_or_phone = email_or_phone.trim() ? email_or_phone.trim().toLowerCase() : email_or_phone;
        let hash_email_or_phone = md5(new_email_or_phone);
        const regionResponse = await axios.get(`/v1/service_region/${hash_email_or_phone}?module_name=${open_url}`);
        if (regionResponse.status === 200 && regionResponse.data) {
            if (regionResponse.data.region !== config.default_region) {
                if (sessionStorage.current_region_url) {
                    sessionStorage.current_region_url = regionResponse.data.base_url;
                }
                else {
                    sessionStorage.setItem('current_region_url', regionResponse.data.base_url);
                }
            }
        }
        return regionResponse;
    } catch (error) {
        handleException(error);
    }
}

export const getBaseURL = async (region, open_url) => {
    try {
        const response = await axios.get(`/v1/service_region/base_url/${region}/${open_url}`);
        if (response.status === 200 && response.data) {
            if (response.data.region !== config.default_region) {
                if (sessionStorage.current_region_url) {
                    sessionStorage.current_region_url = response.data.base_url;
                }
                else {
                    sessionStorage.setItem('current_region_url', response.data.base_url);
                }
            }
        }
        return response;

    } catch (error) {
        handleException(error);
    }
}


export const decodeUserToken = async () => {
    try {
        const response = await axios.get(`/v1/profile`);
        if(response && response.status === 200 && response.data){
            return response.data
        }
        else{
            return {};
        }
    } catch (error) {
        handleException(error);
    }
}

export const resetSessionStorage = () => {
    if (sessionStorage.current_region_url) {
        sessionStorage.removeItem("current_region_url");
    }
} 


export const checkIFTokenValid = async () => {
    try {
        const response = await axios.get(`/v3/user_information`);
        if(response && response.status === 200){
            return response;
        }
    } catch (error) {
        handleException(error);
    }
}